import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { FormContext } from './FormContext.js';

const defaultProps = {
    alternative: false,
    rounding: 'sharp',
    sizing: 'medium',
};
const _Form = forwardRef((props, ref) => {
    const { children, alternative, rounding, sizing, ...rest } = props;
    return (React.createElement("form", { ...rest, ref: ref },
        React.createElement(FormContext.Provider, { value: {
                alternative: alternative,
                rounding: rounding,
                sizing: sizing,
            } }, children)));
});
_Form.displayName = '_Form';
const Form = styled(_Form) ``;
Form.defaultProps = defaultProps;

export { Form, defaultProps };
//# sourceMappingURL=Form.js.map
